import Vue from 'vue'
import Router from 'vue-router'

import forward from '@/components/forward'
import smart_mall from '@/components/smart_mall/smart_mall'
import wk_product from '@/components/wk_product/wk_product'
import wk_community from '@/components/wk_community/wk_community'
import wk_community_about from '@/components/wk_community/block/about'
import wk_community_edit from '@/components/wk_community/block/edit_community'

import document from '@/components/document/document'
import help from '@/components/document/help'

import about from '@/components/about/about'
import app1 from '@/components/smart_mall/block/app1'
import app2 from '@/components/smart_mall/block/app2'
import app3 from '@/components/smart_mall/block/app3'
import app4 from '@/components/smart_mall/block/app4'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/wk_community_edit',
      name: 'wk_community_edit',
      component: wk_community_edit
    },
    {
      path: '/document',
      name: 'document',
      component:document
    },
    {
      path: '/help',
      name: 'help',
      component:help
    },
    {
      path: '/',
      name: 'forward',
      component: forward,
      redirect:'/smart_mall',
      children:[
        {
          path: 'smart_mall',
          name: 'smart_mall',
          component: smart_mall,
        },
        {
          path: 'wk_product',
          name: 'wk_product',
          component: wk_product,
        },
        {
          path: 'wk_community',
          name: 'wk_community',
          component: wk_community,
        },
        {
          path: 'wk_community_about',
          name: 'wk_community_about',
          component: wk_community_about,
        },
        {
          path: 'about',
          name: 'about',
          component: about,
        },
        {
          path: 'app1',
          name: 'app1',
          component: app1,
        },
        {
          path: 'app2',
          name: 'app2',
          component: app2,
        },
        {
          path: 'app3',
          name: 'app3',
          component: app3,
        },
        {
          path: 'app4',
          name: 'app4',
          component: app4,
        }
      ]
    }
  ],
  mode: 'history',
  base: 'official'
})



// WEBPACK FOOTER //
// ./src/router/index.js